package com.shadowings.gero.data.lessons.chapter11

import com.shadowings.gero.data.lessons.inlineMeaning
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.fillMaxWidth
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.unit.dp
import com.shadowings.gero.data.lessons.chapter1.getFamousNamesQuiz
import com.shadowings.gero.data.lessons.chapter2.getNumberGenderQuizContent
import com.shadowings.gero.data.lessons.chapter2.getVocabAnimalsContent
import com.shadowings.gero.data.lessons.chapter2.getVocabAnimalsQuizContent
import com.shadowings.gero.data.lessons.chapter2.getVocabFoodContent
import com.shadowings.gero.data.lessons.chapter2.getVocabFoodQuizContent
import com.shadowings.gero.data.lessons.chapter2.getVocabHumansContent
import com.shadowings.gero.data.lessons.chapter2.getVocabHumansQuizContent
import com.shadowings.gero.data.lessons.chapter3.getGenitivoDirettoQuizContent
import com.shadowings.gero.data.lessons.chapter4.getApposizioneQuizContent
import com.shadowings.gero.data.lessons.chapter9.getParticleIwQuizContent
import com.shadowings.gero.data.lessons.toHieroExplanation
import com.shadowings.gero.data.repository.Hiero
import com.shadowings.gero.domain.model.Characters
import com.shadowings.gero.domain.model.ExplanationContent
import com.shadowings.gero.domain.model.Faces
import com.shadowings.gero.domain.model.IExplanation
import com.shadowings.gero.domain.model.IQuizContent
import com.shadowings.gero.domain.model.TrueFalseContent
import com.shadowings.gero.presentation.component.MdCWord
import com.shadowings.gero.presentation.model.Word
import gero.composeapp.generated.resources.Res
import gero.composeapp.generated.resources.exp_content_una_definizione_1
import gero.composeapp.generated.resources.exp_content_una_definizione_10
import gero.composeapp.generated.resources.exp_content_una_definizione_11
import gero.composeapp.generated.resources.exp_content_una_definizione_12
import gero.composeapp.generated.resources.exp_content_una_definizione_13
import gero.composeapp.generated.resources.exp_content_una_definizione_14
import gero.composeapp.generated.resources.exp_content_una_definizione_15
import gero.composeapp.generated.resources.exp_content_una_definizione_16
import gero.composeapp.generated.resources.exp_content_una_definizione_17
import gero.composeapp.generated.resources.exp_content_una_definizione_18
import gero.composeapp.generated.resources.exp_content_una_definizione_2
import gero.composeapp.generated.resources.exp_content_una_definizione_3
import gero.composeapp.generated.resources.exp_content_una_definizione_4
import gero.composeapp.generated.resources.exp_content_una_definizione_5
import gero.composeapp.generated.resources.exp_content_una_definizione_6
import gero.composeapp.generated.resources.exp_content_una_definizione_7
import gero.composeapp.generated.resources.exp_content_una_definizione_8
import gero.composeapp.generated.resources.exp_content_una_definizione_9
import gero.composeapp.generated.resources.exp_content_word_reading_and_meaning
import gero.composeapp.generated.resources.exp_title_una_definizione
import gero.composeapp.generated.resources.exp_title_word_name
import gero.composeapp.generated.resources.quiz_una_definizione_1
import gero.composeapp.generated.resources.quiz_una_definizione_2
import gero.composeapp.generated.resources.quiz_una_definizione_3
import gero.composeapp.generated.resources.quiz_una_definizione_4

fun getUnaDefinizioneContent(
    hiero: List<Hiero>,
    words: List<Word>,
    languageCode: String
): List<IExplanation> {
    return listOf(
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_1,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_2,
            face = Faces.Happy,
            character = Characters.Zeta,
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_3,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_4,
            face = Faces.Serious,
            character = Characters.Masko,
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_5,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_6,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_7,
            face = Faces.Idle,
            character = Characters.Alyn,
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_8,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "M17-A1-D2h2:Z1-G17-D36:N29",
                        rtl = false,
                        cart = false,
                        size = 64.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_9,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "M17",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_10,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "A1",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_11,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "D2h2:Z1",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_12,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_13,
            face = Faces.Happy,
            character = Characters.Alyn,
        )) + listOf("D2").toHieroExplanation(hiero, languageCode) + (
            words.filter { it.id == "ACCA_ERRE" }.map { word ->
                ExplanationContent(
                    title = Res.string.exp_title_word_name,
                    titleArgs = listOf(word.getMeaning(languageCode)),
                    content = Res.string.exp_content_word_reading_and_meaning,
                    contentArgs = listOf(
                        word.reading,
                        word.inlineMeaning(languageCode),
                        word.getNote(languageCode)
                    ),
                    face = Faces.Happy,
                    character = Characters.Nilo,
                    composable = {
                        MdCWord(
                            word.gardiner,
                            rtl = false,
                            cart = false,
                            size = 96.dp
                        )
                    },
                    wordId = word.id
                )
            }
            ) + listOf(
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_14,
            face = Faces.Surprised,
            character = Characters.Nilo,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "G17-D36:N29",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_15,
            face = Faces.Happy,
            character = Characters.Alyn,
            composable = {
                Box(
                    modifier = Modifier.fillMaxWidth(),
                    contentAlignment = Alignment.Center
                ) {
                    MdCWord(
                        word = "G17-D36:N29",
                        rtl = false,
                        cart = false,
                        size = 72.dp
                    )
                }
            }
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_16,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_17,
            face = Faces.Surprised,
            character = Characters.Nilo,
        ),
        ExplanationContent(
            title = Res.string.exp_title_una_definizione,
            content = Res.string.exp_content_una_definizione_18,
            face = Faces.Happy,
            character = Characters.Alyn,
        ),
    )
}

fun getUnaDefinizioneQuizContent(
    words: List<Word>,
    languageCode: String
): List<IQuizContent> {
    val specificQuizzes: List<IQuizContent> = listOf(
        TrueFalseContent(
            text = Res.string.quiz_una_definizione_1,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_una_definizione_2,
            correct = true
        ),
        TrueFalseContent(
            text = Res.string.quiz_una_definizione_3,
            correct = false
        ),
        TrueFalseContent(
            text = Res.string.quiz_una_definizione_4,
            correct = false
        ),
    )

    val reviewPool: List<IQuizContent> = (
            getFamousNamesQuiz(words, languageCode) +
                    getVocabFoodQuizContent(
                        getVocabFoodContent(words, languageCode),
                        words,
                        languageCode
                    ) +
                    getVocabAnimalsQuizContent(
                        getVocabAnimalsContent(words, languageCode),
                        words,
                        languageCode
                    ) +
                    getVocabHumansQuizContent(
                        getVocabHumansContent(words, languageCode),
                        words,
                        languageCode
                    ) +
                    getNumberGenderQuizContent() +
                    getGenitivoDirettoQuizContent(words, languageCode) +
                    getApposizioneQuizContent(words, languageCode) +
                    getParticleIwQuizContent()
            ).shuffled()

    val reviewQuizzes = reviewPool.take(6)

    return specificQuizzes + reviewQuizzes
}
